<template>
  <div class="container">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.crm_stock_manage_export"
        >
          <el-button
            class="table-set"
            @click="exportTable('stockOrderExport',formSearch)"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item
          v-if="funcView.crm_stock_manage_delay_applay"
        >
        <!--selectedData.stockState 待入库 1  已入库 2-->
          <el-button
            type="primary"
            :disabled="!selectedData || (`${selectedData.stockState}` !== '3' && `${selectedData.isExistBill}`!=='0') "
            @click="delayApply"
          >{{funcView.crm_stock_manage_delay_applay}}</el-button>

        </el-form-item>
         <el-form-item
          v-if="funcView.crm_stock_manage_return_renovation"
        >
          <el-button
            type="primary"
             :disabled="!selectedData || `${selectedData.allowRenovate}` !== '1'  || `${selectedData.stockState}`!=='2' "
            @click="refurbishApply"
          >{{funcView.crm_stock_manage_return_renovation}}</el-button>
        </el-form-item>
        <!-- 售后翻新 -->
         <el-form-item
          v-if="funcView.crm_stock_renovate"
        >
          <el-button
            type="primary"
            :disabled="!selectedData|| `${selectedData.allowRenovateSc}` !== '1'  || `${selectedData.stockState}`!=='2' "
            @click="onRefurbish"
          >{{funcView.crm_stock_renovate}}</el-button>
        </el-form-item>
        <!-- 批量售后翻新 -->

        <el-button v-if="funcView.crm_stock_batch_renovate" type="primary" @click="addBatchRenovate">
          <i class="icon icon-piliangtianjia"></i>
          &ensp;{{ funcView.crm_stock_batch_renovate }}
        </el-button>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
           ref="column"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('crm_manage.ji_shen_hao')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
         <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
         <el-form-item :label="$t('crm_manage.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.she_bei_lei_xing')">
          <custom-select v-model="formSearch.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.ku_cun_kai_shi_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.ku_cun_fang')">
          <el-input style="width:100%;" v-model="formSearch.orgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.yu_ji_shou_fei_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.nextBillDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        v-if="funcView.crm_stock_manage_list"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :tableCode="tableCode"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        v-model="selectedData"
        type="radio"
        :slots="['freeDuration']"
        >
          <!-- 操作 -->
          <template slot="freeDuration" slot-scope="scope">
            {{scope.row.freeDuration}}{{getDicValue('crm_sharing_rule_free_unit', scope.row.freeUnit)}}
          </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>

    <stock-approval-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      :model="dialogModel1"
      :success="getTableList"
    ></stock-approval-dialog>
 <!--批量翻新 -->
 <renovate-batch-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></renovate-batch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import stockApprovalDialog from '@/components/approvalCenter/approval_dialog.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import renovateBatchDialog from '@/pages/dms/stock/children/renovate_batch_dialog.vue';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';

export default {
  name: '',
  mixins: [resetFormSearchMixins, tableFilterValueGetParamMixins],
  components: {
    stockApprovalDialog,
    renovateBatchDialog
  },
  props: {},
  data() {
    return {
      tableCode: 'crm_stock',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        search: '',
        productCode: '',
        deviceBizType: '',
        timer: [],
        beginOfStockStartDate: '',
        endOfStockStartDate: '',
        orgName: '',
        nextBillDate: [],
        nextBillStartDate: '',
        nextBillEndDate: ''
      },
      tableList: [],
      totalRows: null,
      // 库存延期申请
      dialogVisible1: false,
      dialogModel1: {},
      selectedData: null,
      // 批量售后翻新
      dialogVisible: false,
      dialogModel: {},

    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.formSearch.beginOfStockStartDate = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : undefined;
      this.formSearch.endOfStockStartDate = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : undefined;
      this.formSearch.nextBillStartDate = this.formSearch.nextBillDate && this.formSearch.nextBillDate[0] ? this.formSearch.nextBillDate[0] : undefined;
      this.formSearch.nextBillEndDate = this.formSearch.nextBillDate && this.formSearch.nextBillDate[1] ? this.formSearch.nextBillDate[1] : undefined;
      this.$getJSON(apis.stockOrderPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    delayApply() {
      this.dialogModel1 = {
        row: this.selectedData,
        type: 'edit',
        changeType: 'change_stock_order',
        changeId: this.selectedData.orderId
      };
      this.dialogVisible1 = true;
    },
    // 申请翻新
    refurbishApply() {
      this.dialogModel1 = {
        row: this.selectedData,
        type: 'add',
        changeType: 'return_hq_renovate_apply',
        // changeId: this.selectedData.orderId
      };
      this.dialogVisible1 = true;
    },
    // 售后翻新
    onRefurbish() {
      const { productCode, bodyNum, deviceId } = this.selectedData;
      const tips = this.$t('crm_manage.nqdyfxgoodsbm', [productCode,bodyNum]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.renovate}/${deviceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 导入国家
    addBatchRenovate() {
      this.dialogVisible = true;
    },
  },
  created() { },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/crmStock/manage');
    this.getTableList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  flex: 1;
  display: flex;
  padding-left: 16px;
  flex-direction: column;
  overflow: hidden;
}
</style>
